// File Metadata:
// Filename: crewSlice.js
// Version: 1.00
// Created: 2025-03-30 14:54:19
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { createSlice } from '@reduxjs/toolkit'

const crewSlice = createSlice({
    name: 'crew',
    initialState: {
        selectedCrew: null,
        scheduleView: 'week',
        filters: {
            showInactive: false,
            crewType: 'all'
        }
    },
    reducers: {
        setSelectedCrew: (state, action) => {
            state.selectedCrew = action.payload
        },
        setScheduleView: (state, action) => {
            state.scheduleView = action.payload
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload }
        }
    }
})

export const { setSelectedCrew, setScheduleView, setFilters } = crewSlice.actions

export default crewSlice.reducer

export const selectCurrentCrew = (state) => state.crew.selectedCrew
export const selectScheduleView = (state) => state.crew.scheduleView
export const selectFilters = (state) => state.crew.filters
